module.exports = require("escape-html");